// Actions do módulo Gestão Fee Fixo.
// Só fazem commit — a camada de API (api/apiFeeFixo*) é quem carrega e chama
// estas actions para armazenar. Componentes chamam a classe de API diretamente;
// nunca uma action de fetch (não existe fetch aqui).

// --- Dashboard ---
export const setDashboard = ({ commit }, payload) =>
  commit('SET_DASHBOARD', payload)
export const setDashboardLoading = ({ commit }, payload) =>
  commit('SET_DASHBOARD_LOADING', payload)

// --- Clientes (por visão) ---
export const setClientesProfissional = ({ commit }, payload) =>
  commit('SET_CLIENTES_PROFISSIONAL', payload)
export const setClientesProfissionalLoading = ({ commit }, payload) =>
  commit('SET_CLIENTES_PROFISSIONAL_LOADING', payload)
export const setClientesEscritorio = ({ commit }, payload) =>
  commit('SET_CLIENTES_ESCRITORIO', payload)
export const setClientesEscritorioLoading = ({ commit }, payload) =>
  commit('SET_CLIENTES_ESCRITORIO_LOADING', payload)
export const setClientesVisao = ({ commit }, visao) =>
  commit('SET_CLIENTES_VISAO', visao)
export const patchStatusCliente = ({ commit }, payload) =>
  commit('PATCH_STATUS_CLIENTE', payload)

// --- Simulação (histórico de análises) ---
export const setAnalises = ({ commit }, payload) =>
  commit('SET_ANALISES', payload)
export const addAnalise = ({ commit }, payload) =>
  commit('ADD_ANALISE', payload)
export const setAnalisesLoading = ({ commit }, payload) =>
  commit('SET_ANALISES_LOADING', payload)

// --- Cliente ativo do módulo (Simulação e Ensaio) ---
export const setClienteAtivo = ({ commit }, payload) =>
  commit('SET_CLIENTE_ATIVO', payload)
export const limparClienteAtivo = ({ commit }) => commit('CLEAR_CLIENTE_ATIVO')
